/*
** Statement's scripts
*/

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/* Video section changes */

// document.addEventListener('DOMContentLoaded', () => {
//   var sectionElements = document.querySelectorAll('.shopify-section--video');

//   sectionElements.forEach((sectionElement) => {
//     var videoMediaElement = sectionElement.querySelector('video-media');

//     var videoElement = sectionElement.querySelector('video');

//     var muteButtonElement = sectionElement.querySelector('[data-video-mute-button]');

//     var playButtonElement = sectionElement.querySelector('[data-video-play-button]');

//     if (videoElement && muteButtonElement) {
//       muteButtonElement.addEventListener('click', () => {
//         if (videoMediaElement) {
//           if (videoElement.muted) {
//             videoMediaElement.removeAttribute('muted');
//           } else {
//             videoMediaElement.setAttribute('muted', '');
//           }
//         }

//         videoElement.muted = !videoElement.muted;
//       });
//     }

//     if (videoElement && playButtonElement) {
//       playButtonElement.addEventListener('click', () => {
//         videoElement[videoElement.paused ? 'play' : 'pause']();
//       });
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.shopify-section--video').forEach(section => {
    const videoMedia = section.querySelector('video-media');
    const video = section.querySelector('video');
    const poster = section.querySelector('.poster-image');

    if (!videoMedia || !video || !poster) return;

    video.classList.add('poster-hidden');
    poster.classList.remove('poster-hidden');
    poster.classList.add('cursor-pointer');

    poster.addEventListener('click', () => {
      poster.classList.add('poster-hidden');
      video.classList.remove('poster-hidden');
      video.play();

      videoMedia.setAttribute('loaded', '');
      videoMedia.setAttribute('can-play', '');
      videoMedia.setAttribute('playing', '');
    });

    video.addEventListener('click', () => {
      video.pause();
      video.classList.add('poster-hidden');
      poster.classList.remove('poster-hidden');

      videoMedia.removeAttribute('loaded');
      videoMedia.removeAttribute('can-play');
      videoMedia.removeAttribute('playing');
    });
  });
});


